import { LogoLibertyMutualHoriz } from '@lmig/lmds-react-logos';

export const LOGOS = {
  liberty: LogoLibertyMutualHoriz,
};
